import React from 'react';
import { Navigate } from 'react-router-dom';
import { isLoggedIn } from '../../utils/auth';
import LandingPage from '../../pages/LandingPage';

export default function RootRedirect() {
  if (isLoggedIn()) {
    return <Navigate to="/dashboard" replace />;
  }
  return <LandingPage />;
}
